module.exports = __webpack_public_path__ + "img/dapps.0b88c1ea.svg";